import { getUnixTime, subMonths } from 'date-fns'
import type React from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'
import H3 from '@/components/H3'
import LoadingSpinner from '@/components/LoadingSpinner'
import { useRerunSubjectResultsMutation } from '@/lib/apollo/mutation/rerun-subject-results'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
}

const DataDogButton = styled(Button)`
  background: #632ca6;
  img {
    max-width: 18px;
    margin: 0;
    padding: 0;
  }
`

const ActionsPanel: React.FC<Props> = ({ customerId, applicationId, subjectId }) => {
  const [rerunResults, { loading, error }] = useRerunSubjectResultsMutation()

  function openInDatadog(subjectId: string) {
    const today = new Date()
    const from = getUnixTime(subMonths(today, 1)) * 1000
    const to = getUnixTime(today) * 1000
    return window.open(
      `https://app.datadoghq.com/logs?query=@subjectId:${subjectId} OR ${subjectId} OR @context.subjectId:${subjectId}&from_ts=${from}&to_ts=${to}`,
      '_blank',
    )
  }

  return (
    <div>
      <H3>Results</H3>
      {error && (
        <p>An error occured when rerunning the subject results. {error?.message}</p>
      )}
      {loading && <LoadingSpinner />}
      <Button
        disabled={loading}
        onClick={() =>
          rerunResults({
            variables: {
              customerId,
              subjectId,
              applicationId,
            },
          })
        }
      >
        Rerun Results
      </Button>
      <DataDogButton onClick={() => openInDatadog(subjectId)}>
        View Datadog logs
      </DataDogButton>
    </div>
  )
}

export default ActionsPanel
